export const getExternalLinkTarget = () => {
  if (typeof window === "undefined") return "_blank";
  return window.top !== window.self ? "_top" : "_blank";
};

export const openExternalLink = (url: string) => {
  if (typeof window === "undefined") return;

  if (/^(mailto:|tel:|sms:)/i.test(url)) {
    window.location.href = url;
    return;
  }

  const popup = window.open(url, getExternalLinkTarget());

  if (popup) {
    popup.opener = null;
  }
};